/**
 * @desc 库龄分页查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StockAgeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/stockAgePage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
